/* eslint-disable react/jsx-no-undef */

import { Select } from 'antd';
import { useEffect, useState } from 'react';

import {
  animationFuncCustomeOne,
  animationFuncCustomeOne3D,
  animationFuncCustomeOneZoomOutMove,
  animationFuncCustomWiggle,
  animationFuncKenBurns,
  animationFuncMoveZoom,
  animationFuncTyping,
  animationList,
} from '@src/shared/utils/VideoGeneration/helperFunctions/animations';

const { Option } = Select;

interface ResizeDropdownProps {
  store: any;
}

export const AnimationDropdown = ({ store }: ResizeDropdownProps) => {

  const [selectedValue, setSelectedValue] = useState(store?.pages[0]?.children[0]?.animations?.[0]?.name || 'Effects');

  const handleAnimationValueChange = async (value: string) => {
    setSelectedValue(value)
    store.pages.map((page: any) => {
      page.children.map((child: any) => {
        if (child.type === 'image' || child.type === 'video') {
          if (value === 'zoom' || value === 'move') {
            store.getElementById(child.id).set({
              animations: animationFuncMoveZoom(value, page.duration),
            });
          }
          if (value === '3d-perspective') {
            store.getElementById(child.id).set({
              animations: animationFuncCustomeOne3D(page.duration),
            });
          }
          if (value === 'move-zoom') {
            store.getElementById(child.id).set({
              animations: animationFuncCustomeOneZoomOutMove(
                value,
                page.duration
              ),
            });
          }
          if (value === 'zoomIn-out') {
            store.getElementById(child.id).set({
              animations: animationFuncCustomeOneZoomOutMove(
                value,
                page.duration
              ),
            });
          }
          if(value === 'Wiggle'){
           
            store.getElementById(child.id).set({
              animations: animationFuncCustomWiggle(
                value,
                page.duration
              ),
            });
          }
          if(value === 'ken-burns'){
            store.getElementById(child.id).set({
              animations: animationFuncKenBurns(page.duration),
            });
          }
          if(value === 'no-effect'){
            console.log(child.id)
            store.getElementById(child.id).set({
              animations: [],
            });
          }
        } else if (child.type === 'text' && value === 'typing') {
          // Apply typing animation only to text elements
          store.getElementById(child.id).set({
            animations: animationFuncTyping(page.duration),
          });
        } else if (child.type === 'text' && value === 'no-effect') {
          // Handle the no-effect case for text elements
          store.getElementById(child.id).set({
            animations: [],
          });
        }
      });
    });
  };
  useEffect(() => {
  
    if (store?.pages?.[0]?.children?.[0]?.animations?.[0]?.name) {
      setSelectedValue(store?.pages?.[0]?.children?.[0]?.animations?.[0]?.name);
    }
  }, [store]);
  return (
    <div
      style={{
        // width: '20%',
        width: '100%',
        marginTop: '8px',
        // marginLeft: '20px',
        marginBottom: '8px',
        // background: 'white',
      }}
    >
      <Select
        style={{
          width: '100%',
          border: '2px solid rgb(235, 233, 254)',
          borderRadius: '5px',
        }}
        placeholder='Effects'
        optionFilterProp='children'
        onChange={handleAnimationValueChange}
        value={selectedValue}
        dropdownRender={(menu) => <div>{menu}</div>}
      >
        <Option>Effects</Option>
        {animationList.map((data, index) => (
          <Option key={index} value={data.value}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              {data.name}
            </div>
          </Option>
        ))}
      </Select>
    </div>
  );
};
